// AUTO-GENERATED by scripts/generate-category-stock.mjs (prebuild). Do not edit.
// In-stock product count per category, measured from the build product cache.
// -1 means the category's query could not be evaluated from productType
// alone (price bands, FURNITURE_QUERY, no query) and must be treated as visible.

export const UNEVALUATED_STOCK = -1;

/** Every in-stock, sellable product in the build catalogue (About's headline figure). */
export const CATALOGUE_IN_STOCK = 27593;

export const CATEGORY_STOCK: Record<string, number> = {
  "living": 3586,
  "bed-bath": 2403,
  "bedroom": 1607,
  "beds": 761,
  "mattresses": 36,
  "dining": 2720,
  "office": 819,
  "outdoor": 6699,
  "lighting": 2180,
  "decor": 8702,
  "area-rugs": 5704,
  "bathroom": 1012,
  "sofas": 174,
  "love-seats": 133,
  "sectionals": 177,
  "seating-sets": 96,
  "accent-chairs": 269,
  "recliners": 32,
  "ottomans": 316,
  "rocking-chairs": 1,
  "bean-bags": 43,
  "coffee-tables": 522,
  "end-tables": 651,
  "console-tables": 201,
  "tv-stands": 91,
  "bookcases": 327,
  "wall-mounted-shelves": 45,
  "cabinets": 142,
  "sideboards": 402,
  "room-dividers": 213,
  "coat-racks": 53,
  "pet-beds": 10,
  "fireplaces": 32,
  "rug-pads": 28,
  "standard-beds": 456,
  "bunk-beds": 68,
  "loft-beds": 3,
  "bed-sheets": 109,
  "bed-pillows": 40,
  "dressers": 331,
  "headboards": 19,
  "benches": 144,
  "jewelry-boxes": 25,
  "kids-chairs": 9,
  "curtains-drapes": 39,
  "foam-hybrid-mattresses": 29,
  "air-mattress": 3,
  "mattress-toppers": 3,
  "bathroom-vanities": 285,
  "bathroom-storage": 337,
  "shower-doors": 95,
  "shower-curtains": 19,
  "bathtubs": 13,
  "bath-towels": 106,
  "dining-tables": 466,
  "tabletop": 295,
  "dining-chairs": 464,
  "dining-sets": 73,
  "bar-chairs": 593,
  "pantry-cabinets": 315,
  "kitchen-islands": 76,
  "wine-coolers": 13,
  "desks": 349,
  "office-chairs": 131,
  "filing-cabinets": 5,
  "shoe-racks": 121,
  "patio-sets": 79,
  "outdoor-sofas": 2,
  "outdoor-chairs": 203,
  "outdoor-tables": 59,
  "outdoor-ottomans": 12,
  "outdoor-umbrellas": 22,
  "outdoor-heaters": 12,
  "outdoor-rugs": 5256,
  "outdoor-fireplaces": 59,
  "fire-pit-accessories": 18,
  "outdoor-accessories": 183,
  "outdoor-privacy-screens": 292,
  "outdoor-planters": 254,
  "chandeliers": 855,
  "floor-lamps": 197,
  "table-lamps": 573,
  "mirrors": 471,
  "sculptures": 694,
  "vases": 370,
  "throw-pillows": 1316,
  "planters": 292,
  "candle-holders": 174,
  "picture-frames": 184,
  "trays": 152,
  "wall-clocks": 129,
  "baskets-organizers": 66,
  "wall-decor": 3808,
  "nightstands": 364,
  "bedroom-sets": 47,
  "vanity-tables": 43,
  "comforters-duvets": 88,
  "throws-blankets": 556,
  "doormats": 351,
  "ornaments": 122,
  "christmas-trees": 44,
  "peel-and-stick-tiles": 82,
  "candles": 89,
  "lampshades": 154,
  "pendant-lights": 246,
  "wall-lighting": 153,
  "outdoor-hanging-lights": 209,
  "shower-benches": 105,
  "bath-rugs": 52,
  "compact-bedroom": 772,
  "all": -1,
  "best-sellers": -1,
  "new-arrivals": -1,
  "under-100": -1,
  "100-250": -1,
  "table-lamps-under-100": -1,
  "mirrors-under-100": -1,
  "throws-under-100": -1,
  "250-600": -1,
  "modern-minimalist": -1,
  "warm-earthy": -1,
  "architectural": -1,
};

/** True unless the category was measured at exactly zero in-stock products. */
export function hasStock(slug: string): boolean {
  return CATEGORY_STOCK[slug] !== 0;
}

/** Slugs measured at exactly zero in-stock products. */
export const EMPTY_CATEGORY_SLUGS: string[] = [];

/** In-stock products per product type, keyed by the lower-cased type. */
export const TYPE_STOCK: Record<string, number> = Object.fromEntries([
  ["accent chairs", 268],
  ["accent throw pillows", 1316],
  ["air mattress", 3],
  ["area rugs", 17],
  ["artificial plants and trees", 3],
  ["bar & restaurant tables", 25],
  ["bar carts and servers", 34],
  ["bar chairs", 593],
  ["bar tools", 2],
  ["barware and drinkware", 86],
  ["bath accessories", 10],
  ["bath rugs", 52],
  ["bath towels", 96],
  ["bathroom faucets", 1],
  ["bathroom storage & organization", 337],
  ["bathroom vanities", 285],
  ["bathtubs", 13],
  ["bed pillows", 40],
  ["bed sheets", 109],
  ["bedroom furniture sets", 47],
  ["benches", 144],
  ["blanket racks and ladders", 14],
  ["bookcases", 327],
  ["bowls", 55],
  ["bunk beds", 65],
  ["cabinets", 142],
  ["candle holders", 174],
  ["candles", 89],
  ["ceiling lighting", 2],
  ["chandeliers", 855],
  ["christmas ornaments", 121],
  ["christmas trees", 44],
  ["coat hangers", 53],
  ["coffee tables", 522],
  ["comforters and quilts", 41],
  ["console tables", 201],
  ["curtains and drapes", 39],
  ["deck boxes and outdoor/utility storage", 7],
  ["desks", 349],
  ["dining chairs", 464],
  ["dining linens", 29],
  ["dining sets", 73],
  ["dining tables", 466],
  ["dinnerware", 42],
  ["dog beds", 8],
  ["doormats", 351],
  ["doors", 47],
  ["down comforters and duvets", 47],
  ["dressers", 331],
  ["end-side tables", 645],
  ["ergonomic accessories", 7],
  ["filing cabinets", 5],
  ["fire pit accessories", 18],
  ["fireplaces", 32],
  ["flatware", 3],
  ["floor chairs", 43],
  ["floor lamps", 197],
  ["foam, spring and hybrid mattresses", 29],
  ["game tables", 2],
  ["hammocks", 14],
  ["headboards", 19],
  ["indoor planters", 38],
  ["jewelry boxes", 25],
  ["kids chairs", 9],
  ["kitchen & utility sinks", 3],
  ["kitchen accessories", 31],
  ["kitchen carts-islands", 76],
  ["kitchen faucets", 4],
  ["knobs", 197],
  ["lampshades", 154],
  ["living room furniture set", 4],
  ["loft beds", 3],
  ["love seats", 133],
  ["luggage racks", 19],
  ["mattress protectors", 1],
  ["mattress toppers", 3],
  ["mirrors", 471],
  ["nightstands & bedside tables", 364],
  ["office chairs", 131],
  ["organizers", 66],
  ["ottomans", 316],
  ["outdoor accessories-decor-garden-games", 155],
  ["outdoor bar chairs", 42],
  ["outdoor benches", 7],
  ["outdoor chairs", 203],
  ["outdoor dining set", 19],
  ["outdoor fireplaces and firepits", 59],
  ["outdoor furniture - conversation sets", 60],
  ["outdoor gazebo", 1],
  ["outdoor hanging lights", 209],
  ["outdoor heaters", 12],
  ["outdoor ottomans", 12],
  ["outdoor pillows", 3],
  ["outdoor planters", 254],
  ["outdoor privacy screens", 292],
  ["outdoor rugs", 5256],
  ["outdoor sectionals", 1],
  ["outdoor sofas", 1],
  ["outdoor tables", 59],
  ["outdoor throws & blankets", 5],
  ["outdoor umbrellas", 19],
  ["pantry cabinets", 315],
  ["peel and stick tiles", 82],
  ["pendants-hanging lights", 246],
  ["pet bowls", 2],
  ["picture frames", 184],
  ["recliners", 32],
  ["rocking chairs", 1],
  ["room dividers", 213],
  ["rug pads", 28],
  ["sculptures", 694],
  ["seat cushions", 15],
  ["seating sets", 96],
  ["sectionals", 177],
  ["serving bowls", 13],
  ["shoe racks", 121],
  ["shower benches", 105],
  ["shower curtains", 19],
  ["shower doors", 95],
  ["sideboards", 402],
  ["smoker barrel", 7],
  ["sofas", 174],
  ["standard beds", 456],
  ["table lamps", 573],
  ["throws & blankets", 556],
  ["toilets", 4],
  ["tray tables", 6],
  ["trays", 152],
  ["tv stands", 91],
  ["umbrella stands & bases", 2],
  ["vanity tables", 43],
  ["vases", 370],
  ["wall art", 3769],
  ["wall clocks", 129],
  ["wall decor", 33],
  ["wall lighting", 153],
  ["wall mounted shelves", 45],
  ["wall panels", 6],
  ["wine coolers", 13],
  ["wreaths", 1],
]);

/**
 * Shopify's product_type: filter matches on contained words. Per lower-cased
 * type: the other catalogue types its filter also returns, to be negated.
 */
export const TYPE_EXCLUSIONS: Record<string, string[]> = {
  "bar chairs": ["Outdoor Bar Chairs"],
  "benches": ["Outdoor Benches","Shower Benches"],
  "bowls": ["Pet Bowls","Serving Bowls"],
  "cabinets": ["Filing Cabinets","Pantry Cabinets"],
  "doors": ["Shower Doors"],
  "fireplaces": ["Outdoor Fireplaces and Firepits"],
  "ottomans": ["Outdoor Ottomans"],
  "sectionals": ["Outdoor Sectionals"],
  "sofas": ["Outdoor Sofas"],
  "throws & blankets": ["Outdoor Throws & Blankets"],
};
